import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';

// Layouts
import MainLayout from './components/common/MainLayout';
import AuthLayout from './components/common/AuthLayout';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import MapPage from './pages/MapPage';
import MissionsPage from './pages/MissionsPage';
import MissionDetailPage from './pages/MissionDetailPage';
import AnalyticsPage from './pages/AnalyticsPage';

// Missions is hidden by default — set VITE_MISSIONS_ENABLED=true to re-enable.
// The pages still import (small bundle cost, simpler conditional) but the
// routes only mount when the flag is on, so deep links return the catch-all.
const missionsEnabled = import.meta.env.VITE_MISSIONS_ENABLED === 'true';
import ReportsPage from './pages/ReportsPage';
import GeofencesPage from './pages/GeofencesPage';
import SensorsPage from './pages/SensorsPage';
import SensorDetailPage from './pages/SensorDetailPage';
import SettingsPage from './pages/SettingsPage';
import AdminPage from './pages/AdminPage';

// Protected route wrapper
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      {/* Auth routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* Protected routes */}
      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/map" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/map" element={<MapPage />} />
        {missionsEnabled && (
          <>
            <Route path="/missions" element={<MissionsPage />} />
            <Route path="/missions/:missionId" element={<MissionDetailPage />} />
          </>
        )}
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/geofences" element={<GeofencesPage />} />
        <Route path="/sensors" element={<SensorsPage />} />
        <Route path="/sensors/:sensorId" element={<SensorDetailPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/map" replace />} />
    </Routes>
  );
}
